var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"more",on:{"click":_vm.gotoPage}},[_vm._v("全部")])]),_c('course-list',{attrs:{"courses":_vm.courses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }